import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import LanguageContext from 'context/LanguageContext';

import { CareerCard, CareerCardWrapper } from 'components/CareerCard';
import Spinner from 'components/Spinner/Spinner';

function Carriera() {
  const { language } = useContext(LanguageContext);
  const [isLoading, setIsLoading] = useState(true);
  const [careers, setCareers] = useState();

  async function getCareers() {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}careers?per_page=100`
      );
      setCareers(response.data);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
    getCareers();
  }, []);

  return (
    <>
      <section className="py-12 text-center">
        {language === 'it' && (
          <>
            <p className="container mx-auto text-4xl font-bold">
              Manda la candidatura a <br />
              <a
                className="font-bold text-blue-500 hover:underline"
                href="mailto:cv@edrivelab.it"
              >
                cv@edrivelab.it
              </a>
            </p>
            <div className="container pb-8 mx-auto mt-4 text-2xl font-light border-b border-blue-500">
              <p className="max-w-4xl mx-auto">
                specificando nell'oggetto la figura professionale per la quale
                ti candidi oppure inviaci la tua candidatura spontanea
              </p>
            </div>
          </>
        )}
        {language === 'en' && (
          <>
            <p className="container mx-auto text-4xl font-bold">
              Send your application to <br />
              <a
                className="font-bold text-blue-500 hover:underline"
                href="mailto:cv@edrivelab.it"
              >
                cv@edrivelab.it
              </a>
            </p>
            <div className="container pb-8 mx-auto mt-4 text-2xl font-light border-b border-blue-500">
              <p className="max-w-4xl mx-auto">
                specifying in the subject line the professional position you are
                applying for, or send us your spontaneous application
              </p>
            </div>
          </>
        )}
      </section>
      <section className="container p-8 mx-auto">
        {/* Posizioni aperte */}
        {isLoading && (
          <div className="flex items-center justify-center">
            <Spinner className="w-16 h-16" />
          </div>
        )}
        {!isLoading && (
          <CareerCardWrapper>
            {careers &&
              careers
                .filter(
                  (item) =>
                    item.acf.status === 'Open' && item.acf.language === language
                )
                .map((item) => (
                  <CareerCard isLoading={isLoading} job={item.acf} />
                ))}
          </CareerCardWrapper>
        )}
      </section>
    </>
  );
}

export default Carriera;
